import img1 from '../assets/1.jpeg';

export default function LocationSection() {
  return (
    <section id="location" className="py-20 bg-white dark:bg-gray-900 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-pink-100 dark:bg-pink-900/30 text-pink-700 dark:text-pink-300 font-semibold text-sm mb-4">
              Preschool near Mayur Park
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
              Tiny Wings Preschool in Chhatrapati Sambhaji Nagar
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
              Tiny Wings Preschool is located near Shri Datta Mandir, behind SBI Mayur Park Branch, near Mayur Park, Harsul T Point, Chhatrapati Sambhaji Nagar, Maharashtra, India.
            </p>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-pink-50 dark:bg-gray-800 rounded-2xl p-5">
                <h3 className="font-bold text-gray-900 dark:text-white mb-2">Local Areas</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Mayur Park, Harsul, Harsul T Point, Datta Mandir, Jalgaon Road, Chhatrapati Sambhaji Nagar</p>
              </div>
              <div className="bg-purple-50 dark:bg-gray-800 rounded-2xl p-5">
                <h3 className="font-bold text-gray-900 dark:text-white mb-2">School Visit</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Parents may call or visit for admission enquiries and classroom guidance.</p>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap gap-4">
              <a href="#contact" className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white font-semibold hover:shadow-lg">
                Schedule a School Visit
              </a>
              <a href="https://www.google.com/maps/search/Tiny+Wings+Preschool+Chhatrapati+Sambhaji+Nagar" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 rounded-full border border-pink-500 text-pink-600 dark:text-pink-300 font-semibold">
                Google Map
              </a>
            </div>
          </div>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={img1}
                alt="Tiny Wings Preschool in Chhatrapati Sambhaji Nagar"
                className="w-full h-[420px] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
